import { render } from "./PollViewer.vue?vue&type=template&id=59824c0f&scoped=true"
import script from "./PollViewer.vue?vue&type=script&lang=js"
export * from "./PollViewer.vue?vue&type=script&lang=js"

import "./PollViewer.vue?vue&type=style&index=0&id=59824c0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59824c0f"]])

export default __exports__